var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstellationA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 272,
    viewBox: "0 0 278 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.355 234.426L85.1505 266.077L85.6298 266.466L111.834 234.814L111.355 234.426Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.179 245.336L111.819 234.763L112.129 234.303L131.489 244.877L131.179 245.336Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.108 245.49L131.798 245.03L192.974 202.429L193.284 202.889L132.108 245.49Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.756 157.559L181.156 157.71L192.766 202.855L193.366 202.704L181.756 157.559Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.712 107.952L181.219 157.552L181.8 157.764L200.293 108.164L199.712 107.952Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.519 85.8621L199.923 107.868L200.252 108.388L235.847 86.382L235.519 85.8621Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M236.803 86.4271L236.339 86.2738L259.415 17.7758L260.035 17.929L236.803 86.4271Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.454 115.236V114.623L199.943 107.727L200.098 108.34L149.454 115.236Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.346 67.1107L113.85 67.4783L149.608 114.688L150.104 114.32L114.346 67.1107Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.527 115.299L128.823 160.525L129.387 160.778L150.091 115.552L149.527 115.299Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1198 163.353V162.74L129.011 160.288V160.901L99.1198 163.353Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.938 162.778L69.0596 174.695L69.2912 175.264L99.1696 163.346L98.938 162.778Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7972 220.205L15.4875 219.899L69.229 174.233L69.6936 174.693L15.7972 220.205Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M192.664 203.502L129.32 161.361L129.63 160.901L192.974 203.042L192.664 203.502Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M278 19.3082L269.947 24.6716L271.186 32.7932L262.977 28.1961L259.88 35.7048L255.233 28.3493L247.799 32.1803L249.193 24.3651L241.45 21.4535L249.813 16.3966L245.012 7.66197L255.233 9.65409L259.88 0L264.371 9.80732L274.128 7.35549L269.482 16.8563L278 19.3082Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M207.842 202.583L201.337 206.873L202.266 213.309L195.607 209.632L193.284 215.761L189.412 209.785L183.527 212.85L184.611 206.567L178.416 204.268L185.075 200.131L181.203 193.082L189.412 194.767L193.129 186.952L196.846 194.921L204.589 192.928L200.872 200.437L207.842 202.583Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6652 219.745L24.0056 224.189L24.9348 231.085L18.1203 227.254L15.4875 233.537L11.6156 227.407L5.26574 230.625L6.50473 224.036L0 221.584L7.12423 217.294L2.94262 209.938L11.6156 211.624L15.4875 203.502L19.2045 211.777L27.4128 209.785L23.5409 217.6L30.6652 219.745Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.085 58.231L116.93 64.5138L122.196 68.1915L115.846 70.0304L113.988 76.16L110.426 70.7966L104.076 71.1031L107.948 65.893L105.934 59.9166L112.129 61.9087L117.085 58.231Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M151.777 104.509L153.481 111.099L159.986 113.55L153.945 117.228L153.791 124.277L148.37 119.527L141.71 121.672L144.498 115.083L140.471 109.413L147.596 109.873L151.777 104.509Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M203.041 101.138V105.888L206.912 108.8L202.111 110.179L200.718 114.93L197.93 110.792L193.129 110.945L196.071 106.961L194.523 102.364L199.324 104.05L203.041 101.138Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.621 224.802L116.466 231.545L122.041 235.682L115.227 237.674L113.213 244.417L109.187 238.441L102.217 238.9L106.554 233.077L104.231 226.641L111.045 228.786L116.621 224.802Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M184.765 150.788V155.538L188.637 158.603L183.836 159.982L182.442 164.732L179.655 160.442L174.699 160.748L177.641 156.764L176.092 152.014L180.894 153.699L184.765 150.788Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4601 263.419L89.0529 266.943L89.9821 271.694L85.4908 269.548L81.1543 272L81.9287 267.096L78.2117 263.878L83.1677 262.959L85.181 258.515L87.659 262.959L92.4601 263.419Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M138.768 242.425L135.515 245.796L136.29 250.7L131.798 248.554L127.462 251.006L128.391 246.103L124.519 242.885L129.475 241.965L131.489 237.521L133.967 241.965L138.768 242.425Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.682 156.611L102.527 161.361L106.554 164.273L101.753 165.652L100.359 170.249L97.571 166.112L92.615 166.418L95.7125 162.434L94.1637 157.837L98.81 159.369L102.682 156.611Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6362 168.104V172.854L76.5081 175.766L71.707 177.145L70.3131 181.742L67.5254 177.605L62.7242 177.911L65.6669 173.927L64.1181 169.33L68.9192 170.862L72.6362 168.104Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.573 153.699V158.45L136.445 161.361L131.643 162.74L130.25 167.491L127.462 163.353L122.506 163.506L125.603 159.522L124.055 154.925L128.856 156.611L132.573 153.699Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M229.679 75.7003L236.494 79.8378L244.082 76.6197L242.069 84.5882L247.799 90.5645L239.436 91.0242L235.719 98.2265L232.467 90.5645L224.413 89.0321L230.608 83.5155L229.679 75.7003Z",
    fill: "#AA946A",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstellationA);
export default __webpack_public_path__ + "static/media/constellationA.c6f611bf1e767d6b42a53dbd2a47decc.svg";
export { ForwardRef as ReactComponent };